import { Component } from '@angular/core';

@Component({
  selector: 'app-cards1-examples-7',
  templateUrl: './cards1-examples-7.component.html'
})
export class Cards1Examples7Component {}
